import { render, staticRenderFns } from "./insects.vue?vue&type=template&id=37b59409&scoped=true&lang=html&"
import script from "./insects.vue?vue&type=script&lang=js&"
export * from "./insects.vue?vue&type=script&lang=js&"
import style0 from "./insects.vue?vue&type=style&index=0&id=37b59409&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b59409",
  null
  
)

export default component.exports